// import { nextTick } from 'vue';
import { createI18n, I18n, Locale } from 'vue-i18n';
import en from '~/locales/en';
import { LanguageCode } from '~/helpers/types';
import { getFromStorage } from '~/helpers/storage';
import { detectLanguageFromBrowser } from '~/helpers/utils';

export const appLanguages = [
    {
        code: 'en',
        file: 'en.ts',
        lang_en: 'English',
        lang_native: 'English',
        flag_code: 'us',
    },
    // Spanish
    {
        code: 'es',
        file: 'es.ts',
        lang_en: 'Spanish',
        lang_native: 'Español',
        flag_code: 'es',
    },
    // German
    {
        code: 'de',
        file: 'de.ts',
        lang_en: 'German',
        lang_native: 'Deutsch',
        flag_code: 'de',
    },
    // French
    {
        code: 'fr',
        file: 'fr.ts',
        lang_en: 'French',
        lang_native: 'Français',
        flag_code: 'fr',
    },
    // Italian
    {
        code: 'it',
        file: 'it.ts',
        lang_en: 'Italian',
        lang_native: 'Italiano',
        flag_code: 'it',
    },
    // Arabic
    {
        code: 'ar',
        file: 'ar.ts',
        lang_en: 'Arabic',
        lang_native: 'العربية',
        flag_code: 'ae',
        rtl: true,
    },
    // Russian
    {
        code: 'ru',
        file: 'ru.ts',
        lang_en: 'Russian',
        lang_native: 'Русский',
        flag_code: 'ru',
    },
    // Bengali
    {
        code: 'bn',
        file: 'bn.ts',
        lang_en: 'Bengali',
        lang_native: 'বাংলা',
        flag_code: 'bd',
    },
    // Urdu
    {
        code: 'ur',
        file: 'ur.ts',
        lang_en: 'Urdu',
        lang_native: 'اردو',
        flag_code: 'pk',
        rtl: true,
    },
    // Vietnamese
    {
        code: 'vi',
        file: 'vi.ts',
        lang_en: 'Vietnamese',
        lang_native: 'Tiếng Việt',
        flag_code: 'vn',
    },
    // Thai
    {
        code: 'th',
        file: 'th.ts',
        lang_en: 'Thai',
        lang_native: 'ไทย',
        flag_code: 'th',
    },
    // Portuguese
    {
        code: 'pt',
        file: 'pt.ts',
        lang_en: 'Portuguese',
        lang_native: 'Português',
        flag_code: 'pt',
    },
    // Turkish
    {
        code: 'tr',
        file: 'tr.ts',
        lang_en: 'Turkish',
        lang_native: 'Türkçe',
        flag_code: 'tr',
    },
    // Brazilian Portuguese
    {
        code: 'pt-BR',
        file: 'pt-BR.ts',
        lang_en: 'Brazilian Portuguese',
        lang_native: 'Português Brasileiro',
        flag_code: 'br',
    },
    // Dutch
    {
        code: 'nl',
        file: 'nl.ts',
        lang_en: 'Dutch',
        lang_native: 'Nederlands',
        flag_code: 'nl',
    },
    // Czech
    {
        code: 'cs',
        file: 'cs.ts',
        lang_en: 'Czech',
        lang_native: 'Čeština',
        flag_code: 'cz',
    },
    // Polish
    {
        code: 'pl',
        file: 'pl.ts',
        lang_en: 'Polish',
        lang_native: 'Polski',
        flag_code: 'pl',
    },
    // Norwegian
    {
        code: 'no',
        file: 'no.ts',
        lang_en: 'Norwegian',
        lang_native: 'Norsk',
        flag_code: 'no',
    },
    // Slovenian
    {
        code: 'sl',
        file: 'sl.ts',
        lang_en: 'Slovenian',
        lang_native: 'Slovenščina',
        flag_code: 'si',
    },
    // Swedish
    {
        code: 'sv',
        file: 'sv.ts',
        lang_en: 'Swedish',
        lang_native: 'Svenska',
        flag_code: 'se',
    },
    // Finnish
    {
        code: 'fi',
        file: 'fi.ts',
        lang_en: 'Finnish',
        lang_native: 'Suomi',
        flag_code: 'fi',
    },
    // Japanese
    {
        code: 'ja',
        file: 'ja.ts',
        lang_en: 'Japanese',
        lang_native: '日本語',
        flag_code: 'jp',
    },
    // Korean
    {
        code: 'ko',
        file: 'ko.ts',
        lang_en: 'Korean',
        lang_native: '한국어',
        flag_code: 'kr',
    },
    // Bulgarian
    {
        code: 'bg',
        file: 'bg.ts',
        lang_en: 'Bulgarian',
        lang_native: 'Български',
        flag_code: 'bg',
    },
    // Ukrainian
    {
        code: 'uk',
        file: 'uk.ts',
        lang_en: 'Ukrainian',
        lang_native: 'Українська',
        flag_code: 'ua',
    },
    // Swahili
    {
        code: 'sw',
        file: 'sw.ts',
        lang_en: 'Swahili',
        lang_native: 'Kiswahili',
        flag_code: 'tz',
    },
    // Tamil
    {
        code: 'ta',
        file: 'ta.ts',
        lang_en: 'Tamil',
        lang_native: 'தமிழ்',
        flag_code: 'in',
    },
    // Malay
    {
        code: 'ms',
        file: 'ms.ts',
        lang_en: 'Malay',
        lang_native: 'Bahasa Melayu',
        flag_code: 'my',
    },
    // Javanese
    {
        code: 'jv',
        file: 'jv.ts',
        lang_en: 'Javanese',
        lang_native: 'Basa Jawa',
        flag_code: 'id',
    },
    // Punjabi
    {
        code: 'pa',
        file: 'pa.ts',
        lang_en: 'Punjabi',
        lang_native: 'ਪੰਜਾਬੀ',
        flag_code: 'in',
    },
    // Hindi
    {
        code: 'hi',
        file: 'hi.ts',
        lang_en: 'Hindi',
        lang_native: 'हिन्दी',
        flag_code: 'in',
    },
    // Chinese (Simplified)
    {
        code: 'zh-CN',
        file: 'zh-CN.ts',
        lang_en: 'Chinese (Simplified)',
        lang_native: '简体中文',
        flag_code: 'cn',
    },
    // Chinese (Traditional)
    {
        code: 'zh-TW',
        file: 'zh-TW.ts',
        lang_en: 'Chinese (Traditional)',
        lang_native: '繁體中文',
        flag_code: 'tw',
    },
] as const;

/**
 * Returns i18n format keys (code, file)
 */
export function getLanguagesForI18n() {
    return appLanguages.map((lang) => ({
        code: lang.code,
        file: lang.file,
    }));
}

export function getAvailableLanguageCodes() {
    return appLanguages.map((lang) => lang.code);
}

// Create Vue I18n instance.
export const i18n = createI18n({
    locales: getLanguagesForI18n(),
    legacy: false,
    // injects $i18n into components
    globalInjection: true,
    locale: 'en',
    fallbackLocale: 'en',
    // will be lazy-loaded when setting locale
    messages: {},
});

i18n.global.setLocaleMessage('en', en);

// export const SUPPORT_LOCALES = ['en'];

export async function defineI18nLocale(locale: Locale) {
    // load locale messages with dynamic import
    const messages = await import(`~/locales/${locale}.ts`);

    return messages.default;
}

export function setupI18n(options = { locale: 'en' }) {
    const i18n = createI18n(options);
    setI18nLanguage(options.locale);
    return i18n;
}

export function getLocale(i18n: I18n): string {
    return typeof i18n.global.locale === 'string'
        ? i18n.global.locale
        : i18n.global.locale.value;
}

// Set new locale.
export async function setLocale(locale: Locale) {
    // Load locale if not available yet.
    if (!i18n.global.availableLocales.includes(locale)) {
        const messages = await loadLocaleMessages(locale);

        // fetch() error occurred.
        if (messages === undefined) {
            return;
        }

        // Add locale.
        i18n.global.setLocaleMessage(locale, messages);
    }

    // Set locale.
    i18n.global.locale.value = locale;
}

// export function setLocale(i18n: I18n, locale: Locale): void {
//     i18n.global.locale.value = locale;
// }

export function setI18nLanguage(locale: Locale) {
    setLocale(locale);
    /**
     * NOTE:
     * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
     * The following is an example for axios.
     *
     * axios.defaults.headers.common['Accept-Language'] = locale
     */
    document.querySelector('html')?.setAttribute('lang', locale);

    if (isRtl(locale as LanguageCode)) {
        document.documentElement.setAttribute('dir', 'rtl');
    } else {
        document.documentElement.removeAttribute('dir');
    }
}

export async function loadLocaleMessages(locale: Locale) {
    // load locale messages with dynamic import
    const messages = await import(
        /* webpackChunkName: "locale-[request]" */ `~/locales/${locale}.ts`
    );

    // set locale and locale message
    // i18n.global.setLocaleMessage(locale, messages.default);

    // return nextTick();
    return messages.default;
}

export function isRtl(code: LanguageCode) {
    const rtlLanguages = [
        'ar', // Arabic
        'he', // Hebrew
        'fa', // Persian
        'ur', // Urdu
        'dv', // Divehi
        'yi', // Yiddish
        'ps', // Pashto
        'sd', // Sindhi
        'ug', // Uyghur
    ];

    return rtlLanguages.includes(code);
}

export async function detectLangOnPageLoad(): Promise<
    LanguageCode | undefined | null
> {
    let langDetected;
    // 1) read theme from localstorage by default
    const langFromStorage = await getFromStorage('lang');
    if (
        langFromStorage &&
        getAvailableLanguageCodes().includes(langFromStorage as LanguageCode)
    ) {
        langDetected = langFromStorage;
    }

    if (!langDetected) {
        // 2) read from browser
        const langFromBrowser = detectLanguageFromBrowser();
        if (
            getAvailableLanguageCodes().includes(
                langFromBrowser as LanguageCode
            )
        ) {
            langDetected = langFromBrowser;
        }
    }
    return langDetected;
}
